import { FormFieldTypes } from "../../../data/formFieldType";

export const ViewGreenMarkProjectFormData = {
    name: "AdditionalInfo",
    initialState: {
        searchText: '',
        projects: null,
        awardRating: '',
        greenMarkCategory: '',
    },
    formFields: [
        {
            id: "searchText",
            lable: "GMP Name/ GMP Number",
            Field_Name: "GMP Name/ GMP Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchText",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3",
            },
        },
            {
            id: "projectNumber",
            lable: "Project Number",
            Field_Name: "Project Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "projectNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3",
            },
        },
             {
            id: "projectName",
            lable: "Project Name",
            Field_Name: "Project Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "projectName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3",
            },
        },
        {
            id: "projects",
            lable: "Status",
            Field_Name: "Status",
            fieldType: FormFieldTypes.SELECT,
            dataField: "projects",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12"
            }
        },
        {
            id: "awardRating",
            lable: "Award Rating",
            Field_Name: "Award rating",
            fieldType: FormFieldTypes.SELECT,
            dataField: "awardRating",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12"
            }
        },
        {
            id: "greenMarkCategory",
            lable: "Green Mark Category",
            Field_Name: "Green Mark category",
            fieldType: FormFieldTypes.SELECT,
            dataField: "greenMarkCategory",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12"
            }
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}